import jquery from "jquery";
import React from "react";
import createReactClass from "create-react-class";
import ReactDOM from "react-dom";

window.React = React;
window.createReactClass = createReactClass;
window.ReactDOM = ReactDOM;
window.$ = window.jQuery = jquery;
